var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Select, Option } from "@mui/joy";
import layoutComponentsDictionary from "../../layout/layoutComponentsDictionary";
import { useContext } from "react";
import { FormSettingsContext } from "../../utils";
import { Spacing } from "../../properties/spacing";
import { Color } from "../../properties/color";
/**
 * Settings of Etc Field
 *
 */
export function EtcFieldSettings(_a) {
    var _b;
    var moduleName = _a.moduleName, layoutName = _a.layoutName, packageName = _a.packageName, fieldDefs = _a.fieldDefs, studioFields = _a.studioFields;
    var _c = useContext(FormSettingsContext), settings = _c.settings, editedSettings = _c.editedSettings;
    var current = settings.currentComponent || {};
    var s = current.settings || {};
    var field = s.field || {};
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "p-4 pb-16" }, { children: _jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx("label", __assign({ className: "block mb-2 font-bold text-gray-700 text-md" }, { children: "Lier au champ" })), _jsx(Select, __assign({ className: "w-80 mb-2", size: "md", defaultValue: field, value: field, onChange: function (event, value) {
                            editedSettings(__assign(__assign({}, settings), { component: {
                                    id: settings.target,
                                    type: "etc-field",
                                    settings: __assign({ field: value }, fieldDefs[value]),
                                }, currentComponent: {
                                    id: settings.target,
                                    type: "etc-field",
                                    settings: __assign({ field: value }, fieldDefs[value]),
                                }, isDirty: true, newLayout: settings.newLayout }));
                        } }, { children: fieldDefs &&
                            ((_b = Object.values(fieldDefs)) === null || _b === void 0 ? void 0 : _b.map(function (item) { return (_jsx(Option, __assign({ value: item.name }, { children: item.vname }), item.name)); })) })), _jsx(Spacing, {}), _jsx(Color, {})] })) })) }));
}
layoutComponentsDictionary.registerLayoutComponent("etc-field-settings", EtcFieldSettings);
